import BarcodeScanController from './BarcodeScanController';
// import Loader from 'utils/Loader';
// import { greenColor, redColor, whiteColor } from 'utils/constants';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
function BarcodeScan() {
  const {
    barcodeText,
    barcodeData,
    barcodeError,
    //handleOkButtonClick,
    handleClearButtonClick,
    // handleChange,
    handleTextareaResize,
    handleRemoveBarcode,
    handleProceed,
    handleBarcodesChange,
    handleBarcodesPaste,
  } = BarcodeScanController();

  const shouldRenderTable = barcodeData && barcodeData.length > 0;
  return (
    <div className="bg" style={{ display: 'block' }}>
      {/* {isData ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Data Loading...</span>
        </div>
      ) : null} */}
      <div className="cutrange">
        <span className="font20">BARCODE SCANNER</span>
      </div>
      {/* <div className="cutrange" style={{ justifyContent: 'end' }}>
        <span style={{ marginRight: '20px' }}>Total :</span>
        <input
          value={barcodeData.length}
          readOnly
          type="text"
          name="cfrom"
          style={{ width: '80px', marginRight: '20px', textAlign: 'center' }}
          className={`inp_text`}
          id="cfrom"
        />
      </div> */}
      <div className="vertical-center">
        <div style={{ display: 'flex', flexDirection: 'row', width: '80%' }}>
          <div style={{ flex: 1 }}>
            {/* <textarea
              type="text"
              name="barcodes"
              value={barcodeText}
              className={`form-control inp_text`}
              id="barcodes"
              rows={7}
              cols={50}
              onChange={handleChange}
              onInput={handleTextareaResize}
              autoFocus
            /> */}
            <textarea
              type="text"
              name="barcodes"
              value={barcodeText}
              className={`form-control inp_text`}
              id="barcodes"
              rows={7}
              cols={50}
              onChange={(e) => handleBarcodesChange(e)}
              onPaste={handleBarcodesPaste}
              onInput={handleTextareaResize}
              autoFocus
            />
          </div>
          {/* <div style={{ marginTop: 'auto', marginBottom: '10px', marginLeft: '10px' }}>
            <button onClick={handleOkButtonClick}>OK</button>
          </div> */}
        </div>
        <div style={{ width: '80%' }}>
          <p className="error">{barcodeError}</p>
        </div>
        {shouldRenderTable ? (
          <div className="barcode-so">
            <TableContainer
              component={Paper}
              elevation={3}
              sx={{
                width: '100%',
                margin: 'auto',
                borderRadius: '8px',
                maxHeight: 320
              }}
            >
              <Table stickyHeader size="small" aria-label="Scanned barcode list">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, width: '25%' }}>Barcode</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Material</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 600, width: 120 }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {barcodeData.map((item, index) => (
                    <TableRow key={`${item.barcode}-${index}`} hover>
                      <TableCell sx={{ fontWeight: 600 }}>{item.barcode}</TableCell>
                      <TableCell>{item.materialDesc}</TableCell>
                      <TableCell align="center">
                        <button
                          style={{
                            fontSize: '12px',
                            padding: '6px 14px',
                            borderRadius: '3px',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer'
                          }}
                          onClick={() => handleRemoveBarcode(item.barcode)}
                        >
                          Remove
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ) : null}
      </div>

      <div className="footer-button">
        <button onClick={handleClearButtonClick} style={{ marginRight: '15px' }}>
          {'Clear'}
        </button>
        <button style={{ marginRight: '15px' }} onClick={handleProceed}>
          {'Proceed'}
        </button>
      </div>
    </div>
  );
}

export default BarcodeScan;
